// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"8":"editor","236":"properties","687":"create"}[chunkId] || chunkId) + "." + {"8":"348e11cc","236":"57d3cab6","687":"a5f8a671","871":"08dcdce8"}[chunkId] + ".css";
};